import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const steps = [
  { titleKey: 'payrollExp.step1Title', descKey: 'payrollExp.step1Desc' },
  { titleKey: 'payrollExp.step2Title', descKey: 'payrollExp.step2Desc' },
  { titleKey: 'payrollExp.step3Title', descKey: 'payrollExp.step3Desc' },
];

const PayrollExportsInstructions = () => {
  const { t } = useTranslation();
  return (
  <Card className="border-border">
    <CardHeader>
      <CardTitle className="text-foreground">{t('payrollExp.instructionsTitle')}</CardTitle>
    </CardHeader>
    <CardContent className="text-muted-foreground">
      <div className="space-y-3">
        {steps.map((step, i) => (
          <div key={i} className="flex items-start gap-3">
            <div className="w-6 h-6 bg-primary text-primary-foreground rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0">
              {i + 1}
            </div>
            <div>
              <p className="font-medium">{t(step.titleKey)}</p>
              <p className="text-sm">{t(step.descKey)}</p>
            </div>
          </div>
        ))}
      </div>
    </CardContent>
  </Card>
  );
};

export default PayrollExportsInstructions;
